export default {
  default: {
    filterTemplates: 'Filter Templates',
  },
}
